function AttachmentTile({ icon, label, onClick }) {
  return (
    <button
      onClick={onClick}
      className="flex aspect-square flex-col items-center justify-center gap-2 rounded-2xl border-2 border-sky-200 bg-card p-4 transition-colors hover:bg-accent hover:border-sky-300"
    >
      <div className="text-sky-500">
        {icon}
      </div>
      <span className="text-sm font-medium text-foreground">
        {label}
      </span>
    </button>
  );
}

export default AttachmentTile;
